import styled, { css } from 'styled-components';

export const MainInfoContainer = styled.div`
  position: relative;
  height: 95vh;
  font-size: calc(2vmin);
  color: white;
  text-align: center;
  display: flex;
  align-items: center;
  overflow: hidden;
  justify-content: center;

  ${(props) =>
    props.displayMenuName === 'icon' &&
    (props.alignOption === 'vertical' || props.alignOption === 'area') &&
    css`
      justify-content: flex-start;
    `}
`;
